/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

const stickyContainer = {
  padding: '5px',
  margin: '0',
  zIndex: 10,
  backgroundColor: 'rgba(255, 255, 255, 1)',
  borderRadius: '6px',
  boxShadow: '0 0 7px 1px rgba(122, 126, 135, 33%)',
  border: '2px solid transparent',
};

export const useSelectClusterDataSetsStyles = makeStyles(theme => ({
  dataSetsStepContainer: {
    display: 'flex',
    flexWrap: 'nowrap',
    marginTop: '15px',
    // marginBottom: "60px",
  },
  dataSetsGridContainer: {
    marginLeft: '10px',
    flex: '3 1 55%',
  },
  dataSetsGrid: {
    display: 'grid',
    // gridTemplateColumns: "repeat(auto-fill, minmax(135px, 1fr))",
    // gridTemplateColumns: "repeat(auto-fill, minmax(155px, 1fr))",
    gridTemplateColumns: 'repeat(2, minmax(155px, 1fr))',
    gridGap: '20px',
    minHeight: '349px',
    gridTemplateRows: 'repeat(auto-fit, minmax(130px, min-content))',
  },
  dataSetsCategoriesContainer: {
    // width: "258px",
    minWidth: '228px',
    flex: '2 1 auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  dataSetsCategoriesContainerStickyWrapper: {
    flex: 1,
  },
  divider: {
    width: '100%',
    margin: '30px 0',
    borderTop: '1px solid #EEEEEE',
  },
  dataSetsSummary: {
    fontSize: '14px',
    lineHeight: '18px',
    color: '#1F3F6D',
    fontWeight: 400,

    '& > span': {
      '&:after': {
        content: "'\\2022 '",
        color: theme.palette.text.primary,
        padding: '0 8px',
      },
      '&:last-child:after': {
        display: 'none',
      },
    },
  },
  dataSetsBottomHint: {
    fontSize: '14px',
    lineHeight: '18px',
    color: theme.palette.text.primary,
  },
  loaderContainer: {
    height: '100%',
    maxHeight: '500px',
    minHeight: '150px',
  },
  t: {
    margin: '0 12px 12px',
    fontSize: '12px',
    lineHeight: '15px',
    color: '#7C8089',
  },
  noDataSetsText: {
    color: theme.palette.text.primary,
    fontSize: '12px',
    lineHeight: '15px',
    minHeight: '349px',
  },
  datasetItem: {
    '&$disabled': {
      opacity: '0.5',
      filter: 'blur(0.5px)',
      '& *': {
        cursor: 'default',
      },
    },
  },
  disabled: {},
  disablableBox: {
    '&$disabled': {
      opacity: '0.5',
      filter: 'blur(0.5px)',
      cursor: 'default',
      '& *': {
        cursor: 'default',
      },
    },
  },
  filterControlContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  filterControl: {
    // marginBottom: "15px",
    width: '100%',
    // maxWidth: "258px",
    maxWidth: '228px',
  },
  filterControlLabel: {
    color: '#1F3F6D',
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '20px',
  },

  readonlyCheckbox: {
    padding: 0,
    marginRight: '9px',
  },
  readonlyCheckboxLabel: {
    marginTop: '5px',
    marginLeft: 0,
    wordBreak: 'break-word',
  },
  cardItem: {
    position: 'relative',
  },
  cardItemErrorIcon: {
    color: '#FA634E',
    position: 'absolute',
    bottom: '5px',
    right: '5px',
  },
  filtersContainer: {
    ...stickyContainer,
    position: 'sticky',
    top: 0,
    display: 'flex',
    justifyContent: 'space-between',
  },
  w100: { width: '100%' },
  dataSetsSummaryStickyContainer: {
    position: 'sticky',
    bottom: 0,
    ...stickyContainer,
  },
  ml10: {
    marginLeft: '10px',
  },
  alignCenter: {
    display: 'flex',
    alignItems: 'center',
  },
  controlButtons: {
    padding: '5px',
    position: 'sticky',
    bottom: 0,
    width: '100%',
    background: 'white',
    height: '52px',
    display: 'flex',
    alignItems: 'center',
    marginTop: '14px',
    borderRadius: '6px',
    boxShadow: '0 0 7px 1px rgba(122, 126, 135, 33%)',
    '& > *:not(:first-child)': {
      marginLeft: '16px',
    },
  },
}));
